/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum FooterVariant {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
}
